import { render } from "./RequesterConfirmationModal.vue?vue&type=template&id=fb9a0ed2"
import script from "./RequesterConfirmationModal.vue?vue&type=script&lang=js"
export * from "./RequesterConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__